import { render, staticRenderFns } from "./DiyOrderBill.vue?vue&type=template&id=0a1d15d8&scoped=true&"
import script from "./DiyOrderBill.vue?vue&type=script&lang=js&"
export * from "./DiyOrderBill.vue?vue&type=script&lang=js&"
import style0 from "./DiyOrderBill.vue?vue&type=style&index=0&id=0a1d15d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d15d8",
  null
  
)

export default component.exports